import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { SpinnerSize } from '../../common';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-layout-loading',
  standalone: true,
  imports: [NgIf, SpinnerComponent],
  templateUrl: './layout-loading.component.html',
  styleUrls: ['./layout-loading.component.scss'],
})
export class LayoutLoadingComponent implements OnInit {
  // inputs
  @Input() spinnerSize: SpinnerSize = SpinnerSize.NORMAL;
  @Input() showLoading: boolean = false;
  @Input() backgroundColor : string ;

  constructor() {}

  ngOnInit(): void {}

}
